<template>
	<div class="h-full overflow-y-scroll">
		<div class="pt-4">
			<h3 class="text-2xl font-bold px-4">      		
				Inbox
			</h3>
		</div>

		
		<div v-if="pedidos && ordenesPendientes && ordenesPendientes.length > 0" class="pb-4"> 
			<inbox class="mt-4" :user="'proveedor'" :ordenes="ordenesPendientes" :fields="{pago: proveedor.payments, cliente: true, recoleccion: proveedor.standalone, surtir: !proveedor.standalone, aprobar: true, facturar: true, entregar: true}"></inbox>
		</div>
		<div v-if="pedidos && ordenesPendientes && ordenesPendientes.length == 0" class="pb-4"> 		
			<empty :texto="'¡No tienes ordenes pendientes!'"></empty>
		</div>
	</div>
</template>

<script>	
	import { useRoute } from 'vue-router'
	import { onMounted, ref, computed, watch } from "vue"
	import { utils } from './utils/utils.js'
	import { useLoading } from 'vue-loading-overlay'
	import { store } from '../store.js'

	export default {
		name: 'Order',		
		setup() {
			const route = useRoute()			
			const proveedor = ref({})  				
			const pedidos = ref(null)								

			const loading = useLoading({
				color: "#428b74",
				loader: "spinner"
			});


			async function loadOrders(provider = proveedor.value) {
				let loader = loading.show()
				try {
					pedidos.value = await utils.getPedidosPorProveedor(route.params.proveedor_id, provider.standalone === true)
				} catch (error) {
					if (error.status !== 401) console.log(error)
				} finally {
					loader.hide()
				}
			}

			onMounted( async () => {	
				const data = await utils.getProveedor(route.params.proveedor_id)
				proveedor.value = data
				loadOrders(data)
			})

			watch(() => store.auth, (authorized) => {
				if (authorized && proveedor.value.id) loadOrders()
			})

			const ordenesPendientes = computed( () => {
				if (pedidos.value == null) {
					return []
				}

				return pedidos.value.filter(
					(pedido) => pedido.cancelado !== true && utils.isPendiente('proveedor', pedido)
				)
			})
			
			return {      
				proveedor,
				pedidos,				
				ordenesPendientes
			}
		},
	}
</script>
